import colorsPrefab from '@sizeid/assets/colors.json';

import hexToRgbA from '../utils/hexToRgbA';
import { BASE } from '../components/Box/constants';

import { GlobalThemeType } from './types';

export const WHITE = '#FFF';

const colors = {
  ...colorsPrefab,
  white: WHITE,
};

const globalConfig = {
  primary: colors.blue.default,
};

const backgrounds = {
  primary: colors.black.light[50],
  secondary: colors.black.light[100],
};

const states = {
  success: {
    default: colors.green.default,
    light: colors.green.light[100],
  },
  danger: {
    default: colors.red.default,
    light: colors.red.light[100],
  },
  warning: {
    default: colors.yellow.default,
    light: colors.yellow.light[100],
  },
  opacity: {
    default: 0.7,
    active: 1,
  },
};

const outlines = {
  border: `1px solid ${colors.black.light[50]}`,
  shadow: {
    default: `0 5px 10px 0 rgba(0, 0, 0, 0.1)`,
    active: `inset 0 0 8px 0 ${hexToRgbA(globalConfig.primary, 0.5)}`,
  },
};

const sizes = {
  base: BASE,
  borderRadius: '10px',
  shadowSpace: {
    small: 5,
    large: 10,
  },
  circButton: {
    default: 40,
    large: 48,
  },
};

const text = {
  baseSize: 16,
  lineHeight: 1.428571,
  primary: colors.black.default,
  secondary: colors.black.light[400],
  light: colors.black.light[300],
  dark: colors.black.dark,
  link: colors.blue.default,
};

const breakpoints = {
  xs: '320px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
};

const globalTheme: GlobalThemeType = {
  colors,
  global: globalConfig,
  backgrounds,
  states,
  outlines,
  sizes,
  text,
  breakpoints,
};

export default globalTheme;
